import React from "react";
import { Box, Card, CardContent, Grid, TextField, Typography } from "@mui/material";

/** A titled section card used to break each tab into clean SaaS sections. */
export const Section: React.FC<{ title: string; subtitle?: string; action?: React.ReactNode; children: React.ReactNode }> = ({
  title, subtitle, action, children,
}) => (
  <Card variant="outlined" sx={{ mb: 2.5, borderRadius: 2 }}>
    <CardContent>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: subtitle ? 0.5 : 2 }}>
        <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
        {action}
      </Box>
      {subtitle && <Typography variant="body2" color="text.secondary" mb={2}>{subtitle}</Typography>}
      {children}
    </CardContent>
  </Card>
);

/** A controlled text field laid out in a responsive 2-column grid. */
export const Field: React.FC<{
  label: string; value: any; onChange: (v: string) => void;
  full?: boolean; multiline?: boolean; type?: string; placeholder?: string; select?: boolean; children?: React.ReactNode;
}> = ({ label, value, onChange, full, multiline, type, placeholder, select, children }) => (
  <Grid item xs={12} sm={full ? 12 : 6}>
    <TextField
      label={label}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      size="small"
      type={type}
      select={select}
      placeholder={placeholder}
      multiline={multiline}
      minRows={multiline ? 3 : undefined}
    >
      {children}
    </TextField>
  </Grid>
);

/** Read-only metric tile for usage/billing dashboards. */
export const Metric: React.FC<{ label: string; value: React.ReactNode; color?: string }> = ({ label, value, color }) => (
  <Card variant="outlined" sx={{ borderRadius: 2, minWidth: 150, flex: 1 }}>
    <CardContent>
      <Typography variant="caption" color="text.secondary" textTransform="uppercase" letterSpacing={0.5}>{label}</Typography>
      <Typography variant="h5" fontWeight={700} color={color}>{value}</Typography>
    </CardContent>
  </Card>
);
